import styled from 'styled-components'

const headerFontSettings = `
    color: #ffffff;
    font-family: "Avenir-Light", "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    letter-spacing: 1.5pt;



    @media (min-width: 900px) { 
        font-size: 18px;
    }
`

const buttonSettings = `
    z-index: 7; 
    ${headerFontSettings}
    background: none; 
    border: none;
    text-transform: uppercase;
    text-align: right;
    cursor: pointer;
`

const backgroundSettings = `
    display: inline-block;
    vertical-align: top;
    background-size: contain;
    background-repeat: no-repeat;
`

// const MenuButton = styled.button`
//     // visibility: ${props => props.showButton ? 'visible' : 'hidden'};
//     // pointer-events: ${props => props.showButton ? 'initial' : 'none'};

//     display: flex;
//     flex-direction: column;
//     justify-content: space-around;
//     width: 1.75rem;
//     height: 1.75rem;
//     background: transparent;
//     border: none;
//     cursor: pointer;
//     padding: 0;
//     z-index: 7;
//     display: flex; 
//     align-items: flex-end;
    
//     &:focus {
//       outline: none;
//     }
    
//     div {
//       width: 1.75rem;
//       height: 0.25rem;
//       border-radius: 10px;
//       transition: all 0.3s linear;
//       position: relative;
//       transform-origin: 1px;
//       background: #dfc645;

//       :first-child {
//         transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
//       }
  
//       :nth-child(2) {
//         opacity: ${({ open }) => open ? '0' : '1'};
//         transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
//       }
  
//       :nth-child(3) {
//         transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
//       }
//     }
// `

const StyledHeader = styled.div`
    position: absolute; 
    top: 0; 
    left: 0; 
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 15px;
    box-sizing: border-box;
    align-items: flex-start;

    > * { flex: 1 1 33%; }

    button {
        ${buttonSettings}
        padding: 0;
        margin: 2px 0;
    }

    &:after {
        content: '';
        height: 100%;
        width: 100%;
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        -o-transform: rotate(180deg);
        /* transform: rotate(180deg); */
        position: absolute;
        top: 0;
        right: 0;
        z-index: -1;
        background-image: url(data:image/false;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAADOCAYAAAD/q2joAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyhpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMDY3IDc5LjE1Nzc0NywgMjAxNS8wMy8zMC0yMzo0MDo0MiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKE1hY2ludG9zaCkiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MzYwRUUwODMwQUMxMTFFN0JCRUJCNjU0MEEwQjdFNUQiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MzYwRUUwODQwQUMxMTFFN0JCRUJCNjU0MEEwQjdFNUQiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDozNjBFRTA4MTBBQzExMUU3QkJFQkI2NTQwQTBCN0U1RCIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDozNjBFRTA4MjBBQzExMUU3QkJFQkI2NTQwQTBCN0U1RCIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pg3xgeMAAABYSURBVHjatFM5DgAgCKMk/v/JqCNGlEMZGKS21RQSEWIatbRZ0GfY4fQgDoETjIgknDfO9EkC5DQQ1ih7Kb/jtXuvXZOF72HAt9+lXARC+asQmEvXugADAOstBPr/9MXIAAAAAElFTkSuQmCC);
        background-repeat-x: repeat;
        background-size: contain;
    }
`

const MobileHeaderContent = styled.div`
    display: flex; 
    z-index: ${props => props.isSceneSelectorOpen ? 8 : 6};
    transition: all 0.3s ease-in-out; 
    opacity: ${props => props.showButton ? '1' : '0'};
    visibility: ${props => props.showButton ? 'visible' : 'hidden'};

    @media (min-width: 900px) {
        display: none;
    }

    button {
        transition: all 0.3s ease-in-out;
        position: absolute; 
    }
`

const DesktopHeaderContent = styled.div`

    display: none; 

    transition: all 0.3s ease-in-out; 
    opacity: ${props => props.showButton ? '1' : '0'};
    visibility: ${props => props.showButton ? 'visible' : 'hidden'};

    @media (min-width: 900px) {
        display: flex;
    }
    
    align-items: center; 
    ${headerFontSettings}

    > * { margin-right: 20px; }

    span {
        width: ${props => props.isVideoActive ? '31px' : '47px'};
        height: ${props => props.isVideoActive ? '18px' : '31px'};
        background-image: ${props => props.isVideoActive 
            ? 'url("data:image/png;base64,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");'
            : 'url(data:image/png;base64,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);'
        }
        ${backgroundSettings}   
    }

    p { 
        margin-top: 0; 
        margin-bottom: 0; 
    }

    button {
        height: 30px;
        width: 30px;
        cursor: pointer;
        border-radius: 50%;
        border: 1px dotted #fff;
        transform: none !important;
        background-image: url(../../assets/images/icons/navi/i.png);
        background-size: 20px;
        background-color: rgba(0, 0, 0, 0.3);
        background-position: center;
        z-index: 1;
        ${backgroundSettings}   
        transition: all 0.3s ease-in-out; 
        visibility: ${props => props.isVideoActive ? 'hidden' : 'visible'};
        opacity: ${props => props.isVideoActive ? '0' : '1'};
    }
`

const Logo = styled.img`
    display: none;
    max-width: 150px;
    z-index: 7;

    @media (min-width: 900px) {
        display: block;
    }
`

export { 
    StyledHeader, 
    Logo, 
    MobileHeaderContent,
    DesktopHeaderContent,
    // MenuButton
}